<template>
    <div>
      <div class="w-100 h-100">
        <Nav :rolname="rolname"/>
      </div>
      <div class="content h-100 " style="background:white">
        <HomeVue v-if="page=='home'" @changePage="changePage" @mtdBackCampus="mtdBackCampus" />
        <Asistance v-if="page=='asistance'" @changePage="changePage" @mtdBackCampus="mtdBackCampus" @returnHome="returnHome" />
      </div>
      <div class="footer">
        <FooterVue @mtdChangePage="mtdChangePage" :pageView='page' />
      </div>
    </div>
  </template>
  
  <script>
  import HomeVue from '@/components/Vigilante/Home.vue';
  import Nav from "@/components/Vigilante/Nav.vue";
  import FooterVue from '@/components/Vigilante/Footer.vue';
  import Asistance from '@/components/Vigilante/pages/Asistance.vue';
  
  export default {
    name: "VigilanteView",
    components: {
      Nav,
      HomeVue,
      FooterVue,
      Asistance
    },
    props: {
      rolname: String,
    },
    data() {
      return {
        prefix: 'vigilante',
        page: 'home',
      };
    },
    methods: {
      changePage: function (page) {
        this.page = page;
      },
      returnHome: function () {
        this.page = "home";
      },
      mtdBackCampus: function () {
        this.$emit("mtdBackCampus");
      },
      mtdChangePage: function(page){
        this.page = page;
      },
    },
  };
  </script>